import { render, staticRenderFns } from "./highlight-item.vue?vue&type=template&id=39855c93"
import script from "./highlight-item.vue?vue&type=script&lang=js"
export * from "./highlight-item.vue?vue&type=script&lang=js"
import style0 from "./highlight-item.vue?vue&type=style&index=0&id=39855c93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports